import { FC, useEffect, useState } from "react";

import { addCountryWiseContactInfo } from "./constant";
import FooterV2mobile from "./FooterV2mobile";
import classes from "./FooterV2.module.scss";
import { shallowEqual, useSelector } from "react-redux";
import { AppState } from "@Store/index";
import wrapperHOC from "@Utils/wrapperHOC";
import isMiniProgramUserAgent from "@Utils/isMiniProgramUserAgent";
import useIsApp from "hooks/useIsApp";
import useIsMiniProgram from "hooks/useIsMiniProgram";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import { SiteFooter } from "@Components/SiteFooter/SiteFooter";
import { DEFAULT_FOOTER_RENDER_VARIANT, FooterRenderVariant } from "./footerRenderVariant";

export interface FooterV2Props {
  isReferralPage?: boolean;
  isFestBottomBannerMobile?: boolean;
  /** @default "site" — HomeV3 footer. Use `"legacy"` for the pre-revamp mobile footer. */
  footerVariant?: FooterRenderVariant;
}

const FooterV2: FC<FooterV2Props> = ({
  isReferralPage = false,
  isFestBottomBannerMobile = false,
  footerVariant = DEFAULT_FOOTER_RENDER_VARIANT,
}) => {
  const isApp = useIsApp();
  const isMiniProgram = useIsMiniProgram();
  const { country, isUserLoggedIn } = useSelector(
    ({ appData }: AppState) => ({
      country: appData.country,
      isUserLoggedIn: appData.isUserLoggedIn,
    }),
    shallowEqual,
  );
  const [contactDetails, setContactDetails] = useState([]);

  useEffect(() => {
    const closeZendeskWidgetBeforeUnload = () => {
      // if (typeof zE === "function") {
      //   zE("messenger", "close");
      // }
    };
    window.addEventListener("beforeunload", closeZendeskWidgetBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", closeZendeskWidgetBeforeUnload);
    };
  }, []);

  useEffect(() => {
    const resolveContactInfo = async () => {
      const val: any = addCountryWiseContactInfo(country);
      setContactDetails(val);
    };
    resolveContactInfo();
  }, [country]);

  if (footerVariant === "site") {
    return (
      <SiteFooter
        isReferralPage={isReferralPage}
        isFestBottomBannerMobile={isFestBottomBannerMobile}
      />
    );
  }

  const getFooterClass = () => {
    if (isMiniProgramUserAgent()) return classes.displayNone;
    return isReferralPage ? classes.footerContainerReferralPage : classes.footerContainer;
  };

  if (isApp || isMiniProgram) {
    const showExtraSpaceForReferralPage = isReferralPage && isUserLoggedIn;
    return (
      <div
        className={
          showExtraSpaceForReferralPage
            ? classes.extraSpaceForRefferalPage
            : formatClassNames(
                classes.extraSpace,
                isFestBottomBannerMobile && classes.festBottomBannerMobile,
              )
        }
      />
    );
  }

  return (
    <section className={getFooterClass()}>
      <div className={classes.container} data-testid="footer-section">
        <FooterV2mobile contactDetails={contactDetails} />
      </div>
    </section>
  );
};
export default wrapperHOC(FooterV2, {
  componentName: "FooterV2-Global",
  showForChina: true,
});
